"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ImageBox = require("./ImageBox");
Object.keys(_ImageBox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ImageBox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ImageBox[key];
    }
  });
});
